import React, { useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Message, SubmitResetClearButton, Title } from './ClientUtil';
import { axiosErrorHandler, axiosGetWithHeader, axiosPostWithHeader, axiosResponseHandler, ShowAlertError } from '../Common/axios';
import Spinner from 'react-bootstrap/esm/Spinner';
import Form from 'react-bootstrap/Form';
import { DoubleToDegree, handleInput, handleReset} from '../Common/Util';
import { validateDouble } from './ClientValidate';
import { SingleButton } from '../Login/LoginUtil';

export function ChangeAstrologerConfig (props) {
  const [data, setData] = useState([]);
  const [language, setLanguage] = useState('en-en');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [coordinate, setCoordinate] = useState('');
  const [ayanamsa, setAyanamsa] = useState('');
  const [correction, setCorrection] = useState('');
  const [birthChartType, setBirthChartType] = useState(0);
  const [message, setMessage] = useState('');
  const setMethod = { 
    setLanguage, setDate, setTime, setCoordinate,setAyanamsa,setCorrection,setBirthChartType, setMessage };

  const languageReference = useRef();
  const dateReference = useRef();
  const timeReference = useRef();
  const coordinateReference = useRef();
  const ayanamsaReference = useRef();
  const correctionReference = useRef();
  const birthChartTypeReference = useRef();
  const [errorAlert, setErrorAlert] = useState(null);
  const [success, setSuccess] = useState(false);
  const [spinner, setSpinner] = useState('Loading - Settings Page');
  const navigate = useNavigate();

  const dropdownOptions = [
    { value: 'DarkGreen:White', label: 'Dark Green', bgcolor: 'DarkGreen',color: 'White' },
    { value: 'Green:White', label: 'Green', bgcolor: 'Green', color: 'White' },
    { value: 'ForestGreen:White', label: 'Forest Green', bgcolor: 'ForestGreen', color: 'White' },
    { value: 'LimeGreen:White', label: 'Lime Green', bgcolor: 'LimeGreen', color: 'White' },
    { value: 'LawnGreen:Blue', label: 'Lawn Green', bgcolor: 'LawnGreen', color: 'Blue' },
    { value: 'YellowGreen:Blue', label: 'Yellow Green', bgcolor: 'YellowGreen', color: 'Blue' },
    { value: 'SpringGreen:Blue', label: 'Spring Green', bgcolor: 'SpringGreen', color: 'Blue' },
    { value: 'LightGreen:Blue', label: 'Light Green', bgcolor: 'LightGreen', color: 'Blue' },
    { value: 'PaleGreen:Blue', label: 'Pale Green', bgcolor: 'PaleGreen', color: 'Blue' },
    { value: 'Navy:White', label: 'Navy Blue', bgcolor: 'Navy', color: 'White' },
    { value: 'DarkBlue:White', label: 'Dark Blue', bgcolor: 'DarkBlue', color: 'White' },
    { value: 'Blue:White', label: 'Blue', bgcolor: 'Blue', color: 'White' },
    { value: 'RoyalBlue:White', label: 'Royal Blue', bgcolor: 'RoyalBlue', color: 'White' },
    { value: 'Turquoise:Black', label: 'Turquoise Blue', bgcolor: 'Turquoise', color: 'Black' },
    { value: 'SkyBlue:Black', label: 'Sky Blue', bgcolor: 'SkyBlue', color: 'Black' },
    { value: 'Aqua:Black', label: 'Aqua Blue', bgcolor: 'Aqua', color: 'Black' },
    { value: 'LightBlue:Black', label: 'Light Blue', bgcolor: 'LightBlue', color: 'Black' },
    { value: 'Pink:Blue', label: 'Pink', bgcolor: 'Pink', color: 'Blue' },
    { value: 'LightPink:Blue', label: 'Light Pink', bgcolor: 'LightPink', color: 'Blue' },
    { value: 'HotPink:Blue', label: 'Hot Pink', bgcolor: 'HotPink', color: 'Blue' },
    { value: 'PaleVioletRed:White', label: 'Pale Violet Red', bgcolor: 'PaleVioletRed', color: 'White' },
    { value: 'DeepPink:White', label: 'Deep Pink', bgcolor: 'DeepPink', color: 'White' },
    { value: 'MediumVioletRed:White', label: 'Medium Violet Red', bgcolor: 'MediumVioletRed', color: 'White' },
    { value: 'DarkRed:White', label: 'Dark Red', bgcolor: 'DarkRed', color: 'White' },
    { value: 'FireBrick:White', label: 'Fire Brick Red', bgcolor: 'FireBrick', color: 'White' },
    { value: 'Crimson:White', label: 'Crimson Red', bgcolor: 'Crimson', color: 'White' },
    { value: 'IndianRed:Blue', label: 'Indian Red', bgcolor: 'IndianRed', color: 'Blue' },
    { value: 'Red:Blue', label: 'Red', bgcolor: 'Red', color: 'Blue' },
    { value: 'Salmon:Blue', label: 'Salmon Red', bgcolor: 'Salmon', color: 'Blue' },
    { value: 'LightCoral:Black', label: 'Light Coral Red', bgcolor: 'LightCoral', color: 'Black' },
    { value: 'DarkSalmon:Black', label: 'Dark Salmon Red', bgcolor: 'DarkSalmon', color: 'Black' },
    { value: 'LightSalmon:Black', label: 'Light Salmon Red', bgcolor: 'LightSalmon', color: 'Black' },
    { value: 'Black:White', label: 'Black', bgcolor: 'Black', color: 'White' },
    { value: 'White:Black', label: 'White', bgcolor: 'White', color: 'Black' },
    { value: 'Gold:Blue', label: 'Gold Yellow', bgcolor: 'Gold', color: 'Blue' },
    { value: 'Yellow:Blue', label: 'Yellow', bgcolor: 'Yellow', color: 'Blue' },
    { value: 'LightYellow:Black', label: 'Light Yellow', bgcolor: 'LightYellow', color: 'Black' },
    { value: 'DarkOrange:White', label: 'Dark Orange', bgcolor: 'DarkOrange', color: 'White' },
    { value: 'Orange:Blue', label: 'Orange', bgcolor: 'Orange', color: 'Blue' },
    { value: 'Tomato:Black', label: 'Tomato Orange', bgcolor: 'Tomato', color: 'Black' },
    { value: 'Gray:White', label: 'Gray', bgcolor: 'Gray', color: 'White' },
  ];
  const colorNameArray = ["Favarable (More)","Favarable","Favarable (Less)",
                          "Mixed (+ve)","Mixed","Mixed (-ve)",
                          "Unfavarable (less)","Unfavarable","Unfavarable (More)",];
  const [colorArray,setColorArray] = useState([
    "DarkGreen:White","Green:White","LightGreen:Blue",
    "LightBlue:Black","Blue:White","Pink:Blue",
    "Salmon:Blue","Red:Black","DarkRed:White"
  ]);


  const valueNameArray = ["Primary","Secondary","Supportive","Bad","Worse","Worst"];
  const [valueColorArray,setValueColorArray] = useState(['DarkGreen','Green','Blue','Gray','Red','DarkRed']);
    const colorOptions = ["DarkGreen","Green","LightGreen","LightBlue","Blue","Pink","Salmon","Red","DarkRed","Black","White","Yellow","Orange","Gray"];
  
  function handleColorInput(event,colorValue,index){
    const tempColor = [...colorArray];
    tempColor[index]=event.target.value;
    setColorArray(tempColor);
  }

  function handleColorValueInput(event,colorValue,index){
    const tempColor = [...valueColorArray];
    tempColor[index]=event.target.value;
    setValueColorArray(tempColor);
  }
  

  function init() {
    axiosGetWithHeader("/config/astrologer",
      (response)=>{
        setData(response.data);
        assignDbData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setSpinner(null);
        setErrorAlert(error.message);
      }
    );
  }

  useMemo(() => {
    axiosGetWithHeader("/config/astrologer",
      (response)=>{
        setData(response.data);
        assignDbData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setSpinner(null);
        setErrorAlert(error.message);
      }
    );
  }, []);

  function assignDbData(data){
    setLanguage(data.config0===null||data.config0===undefined?"en-en":data.config0);
    setDate(data.config1);
    setTime(data.config2);
    setCoordinate(data.config3);
    setAyanamsa(data.config4)
    setCorrection(data.config5===null||data.config5===undefined?"0":data.config5);
    setColorArray(data.config6===null||data.config6===undefined?[]:data.config6.split(","));
    setValueColorArray(data.config7===null||data.config7===undefined?[]:data.config7.split(","));
    setBirthChartType(data.config8===null||data.config8===undefined?"0":data.config8);
  }

  const handleBack = (event) => {
    setTimeout(() => {
      navigate('/home.html', { replace: true });
    }, 100);
  }

  const handleSubmit = (event) => {
    var msg='';
    setMessage(msg);
    if(msg==='' && correction!=='') msg = validateDouble(event,"Ayanamsa Correction",correctionReference,correction,-180,180);
    setMessage(msg);

    if(msg==='') {
      const data = {
        config0: language,
        config1: date,
        config2: time,
        config3: coordinate,
        config4: ayanamsa,
        config5: correction==="0"?null:correction,
        config6: colorArray.toString(),
        config7: valueColorArray.toString(),
        config8: birthChartType
      }
      axiosPostWithHeader("/config/astrologer/edit", data,
        (response)=>{
          setMessage(axiosResponseHandler(response, languageReference, ()=>handleReset(setMethod,languageReference), "Settings are updated successfully"));
          init();
          if(response.data.code==='200') {
            setSuccess(true);
          }
        },
        (error)=>{
          setMessage(axiosErrorHandler(languageReference,error));
          setErrorAlert(error.message);
      }
      );
    }
    event.preventDefault();
  }

  const handleDBDataReset =  (event) => {
    assignDbData(data);
    setMessage("");
    languageReference.current.focus();
}

  return(
    <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        <div class="m-0 p-0 row align-items-top">
        <div class="col-sm-12 col-md-12 m-0 p-2 bg-white text-black">
          <Title title="My Settings" urlcallback={handleBack}></Title>
          <div class="row m-0 p-0 w-100 border rounded">
            <div class="col m-0 p-0 justify-content-center">
              <div class="row m-0 p-0 w-100">
                <div class="col-sm-12 col-lg-12 text-center">
                  <Message msg={message} />
                </div>
              </div>  
              {success===false?
              <form method="post" onSubmit={handleSubmit}>
                <div class="row m-0 p-0 w-100">
                  <div class="col-sm-12 col-lg-4">
                      <div class="mb-3 mt-1">
                        <label for="langauage">Language:</label>
                        <Form.Select name="language" ref={languageReference} value={language} onChange={(event)=>handleInput(event,setMethod)}>
                          <option value="en-en">English</option>
                        </Form.Select>
                      </div>

                      <div class="mb-3 mt-1">
                        <label for="date">Date:</label>
                        <Form.Select name="date" ref={dateReference} value={date} onChange={(event)=>handleInput(event,setMethod)}>
                          <option value="dd-MM-yyyy">dd-mm-yyyy</option>
                          <option value="MM-dd-yyyy">mm-dd-yyyy</option>
                          <option value="yyyy-MM-dd">yyyy-mm-dd</option>
                        </Form.Select>
                      </div>

                      <div class="mb-3 mt-1">
                        <label for="time">Time:</label>
                        <Form.Select name="time" ref={timeReference} value={time} onChange={(event)=>handleInput(event,setMethod)}>
                          <option value="hh:mm:ss a">hh:mm:ss am/pm</option>
                          <option value="hh:mm a">hh:mm am/pm</option>
                          <option value="HH:mm:ss">hh:mm:ss (24)</option>
                          <option value="HH:mm">hh:mm (24)</option>
                        </Form.Select>
                      </div>

                      <div class="mb-3 mt-1">
                        <label for="coordinate">Coordinates:</label>
                        <Form.Select name="coordinate" ref={coordinateReference} value={coordinate} onChange={(event)=>handleInput(event,setMethod)}>
                          <option value="N">00° 00' 00" N/E/W/S</option>
                          <option value="Z">(-/+) 00° 00' 00"</option>
                        </Form.Select>
                      </div>

                      <div class="mb-3 mt-1">
                        <label for="ayanamsa">Ayanamsa:</label>
                        <Form.Select name="ayanamsa" ref={ayanamsaReference} value={ayanamsa} onChange={(event)=>handleInput(event,setMethod)}>
                          <option value="0">FAGAN BRADLEY</option>
                          <option value="1">LAHIRI</option>
                          <option value="2">DELUCE</option>
                          <option value="3">RAMAN</option>
                          <option value="4">USHASHASHI</option>
                          <option value="5">KRISHNAMURTI</option>
                          <option value="6">DJWHAL KHUL</option>
                          <option value="7">YUKTESHWAR</option>
                          <option value="8">J N BHASIN</option>
                          <option value="9">BABYL KUGLER 1</option>
                          <option value="10">BABYL KUGLER 2</option>
                          <option value="11">BABYL KUGLER 3</option>
                          <option value="12">BABYL HUBER</option>
                          <option value="13">BABYL ETPSC</option>
                          <option value="14">ALDEBARAN 15TAU</option>
                          <option value="15">HIPPARCHOS</option>
                          <option value="16">SASSANIAN</option>
                          <option value="17">GALCENT 0SAG</option>
                          <option value="18">ZODIAC FIX J2000</option>
                          <option value="19">ZODIAC FIX J1900</option>
                          <option value="20">ZODIAC FIX B1950</option>
                          <option value="21">SURYASIDDHANTA</option>
                          <option value="22">SURYASIDDHANTA MSUN</option>
                          <option value="23">ARYABHATA</option>
                          <option value="24">ARYABHATA MSUN</option>
                          <option value="25">SS REVATI</option>
                          <option value="26">SS CITRA</option>
                          <option value="27">TRUE CITRA</option>
                          <option value="28">TRUE REVATI</option>
                          <option value="29">TRUE PUSHYA</option>
                        </Form.Select>
                      </div>

                      <div class="mb-3 mt-1">
                        <label for="correction">Ayanamsa Correction: ( <DoubleToDegree value={correction} /> )</label>
                        <Form.Control type="input" name="correction" ref={correctionReference} value={correction} onChange={(event)=>handleInput(event,setMethod)}/>
                      </div>

                      <div class="mb-3 mt-1">
                        <label for="birthChartType">Birth Chart Type:</label>
                        <Form.Select name="birthChartType" ref={birthChartTypeReference} value={birthChartType} onChange={(event)=>handleInput(event,setMethod)}>
                          <option value="0">South India</option>
                          <option value="1">North India</option>
                          <option value="2">East India</option>
                          <option value="3">Bhava Chalit</option>
                        </Form.Select>
                      </div>

                  </div>  
                  <div class="col-sm-12 col-lg-4 bg-light">
                    <div class="row align-items-center text-center">
                      <div class="col w-100">
                        <label for="EventColors" class="col-form-label fw-bold">Event Colors</label>
                      </div>
                    </div>
                    {colorArray.map((colorValue,index) => (
                      <div class="row align-items-center m-0 p-1">
                        <div class="col-5">
                          <label for={"colorName"+index} class="col-form-label">{colorNameArray[index]}</label>
                        </div>
                        <div class="col w-100 ">
                          <Form.Select name={"color"+index} value={colorValue} style={{backgroundColor: colorValue.split(":")[0], color: colorValue.split(":")[1]}} onChange={(event)=>handleColorInput(event,colorValue,index)}>
                            {dropdownOptions.map((option) => (
                            <option key={option.value} value={option.value} style={{ backgroundColor: option.bgcolor, color:option.color }} >{option.label}</option>
                            ))}
                          </Form.Select>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div class="col-sm-12 col-lg-4">
                    <div class="row align-items-center text-center">
                      <div class="col w-100">
                        <label for="EventValueColors" class="col-form-label fw-bold">Event Values Colors</label>
                      </div>
                    </div>
                    {valueColorArray.map((colorValue,index) => (
                      <div class="row align-items-center m-0 p-1">
                        <div class="col-5">
                          <label for={"colorName"+index} class="col-form-label">{valueNameArray[index]}</label>
                        </div>
                        <div class="col w-100 ">
                          <Form.Select name={"colorValue"+index} value={colorValue} style={{color: colorValue}} onChange={(event)=>handleColorValueInput(event,colorValue,index)}>
                            {colorOptions.map((option) => (
                            <option key={option} value={option} style={{ color:option }} >{option}</option>
                            ))}
                          </Form.Select>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div class="row m-0 p-0 w-100">
                  <div class="col-sm-12 col-lg-12 text-center">
                    <div class="card-body d-flex justify-content-center p-0 pt-2 ">
                      <div class="">
                        <SubmitResetClearButton callback={()=>handleReset(setMethod,languageReference)} callbackReset={handleDBDataReset} /> 
                      </div>
                    </div>  
                  </div>
                </div>  
              </form>
              :
              <div class="row m-0 p-0 w-100">
                <div class="col-sm-12 col-lg-12 text-center">
                  <div class="card-body d-flex justify-content-center p-0 pt-2 ">
                    <div class="">
                      <SingleButton title="Ok" callback={handleBack}/>
                    </div>
                  </div>  
                </div>
              </div>  
              }

            </div>
          </div>
        </div>
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
      </div>
    </>
  );
}
